// extracted by mini-css-extract-plugin
export default {"header":"FAQ_header__XxXBn","faqInfoCard":"FAQ_faqInfoCard__Pyncn"};